import React, { useState } from 'react'
import PropTypes from 'prop-types'

const RefundContext = React.createContext({})

const RefundContextWrapper = ({ children }) => {
  const [refundType, setRefundType] = useState('-1')

  return (
    <RefundContext.Provider
      value={{
        refundType,
        setRefundType
      }}
    >
      {children}
    </RefundContext.Provider>
  )
}

RefundContextWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export { RefundContext }
export default RefundContextWrapper
